import { Playground, PLAYGROUNG_BG_LIGHTER } from '../../../components/playground/Playground';
import {
    PlaygroundClasses,
    PlaygroundResponsiveClasses,
    PlaygroundPrintClasses,
    PlaygroundNegativeClasses,
    PlaygroundClassesSpacer,
} from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';
import { dummyText } from '../../../utils/data';
import { positions } from '../../../utils/positions';

export const Position = () => (
    <div>
        <Headline anchor='position'>Position</Headline>
        <Playground background={PLAYGROUNG_BG_LIGHTER} example={positionExample} classes={PositionClasses} />
    </div>
);

const positionExample = (
    <div>
        <div className='panel panel-default panel-body position-relative'>
            <button className='btn btn-link btn-icon-only position-absolute top-10 right-10'>
                <span className='uikit-icon icon-cog' aria-hidden='true' />
            </button>
            <h3 className='margin-top-0 margin-bottom-10 padding-right-25'>Lorem ipsum dolor sit amet</h3>
            <div>{dummyText}</div>
        </div>
    </div>
);

const PositionClasses = (
    <>
        <PlaygroundClassesSpacer label='Pixel values' />
        <PlaygroundClasses
            label='Typo'
            classes={['position-relative', 'position-absolute', 'position-fixed', 'position-sticky', 'position-static']}
        />
        <PlaygroundClassesSpacer label='Pixel values' />
        <PlaygroundClasses label='Left' prefix='left-' classes={['none', ...positions.px]} />
        <PlaygroundClasses label='Right' prefix='right-' classes={['none', ...positions.px]} />
        <PlaygroundClasses label='Top' prefix='top-' classes={['none', ...positions.px]} />
        <PlaygroundClasses label='Bottom' prefix='bottom-' classes={['none', ...positions.px]} />
        <PlaygroundClassesSpacer label='Percentage values' />
        <PlaygroundClasses label='Left' prefix='left-' classes={positions.pct} suffix='pct' />
        <PlaygroundClasses label='Right' prefix='right-' classes={positions.pct} suffix='pct' />
        <PlaygroundClasses label='Top' prefix='top-' classes={positions.pct} suffix='pct' />
        <PlaygroundClasses label='Bottom' prefix='bottom-' classes={positions.pct} suffix='pct' />
        <PlaygroundNegativeClasses />
        <PlaygroundResponsiveClasses />
        <PlaygroundPrintClasses />
    </>
);
